import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {ModalType} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IModalPayload, IModalsStore} from "data/stores/modals/modals.store";
import {GIGYA_KEY} from "data/constants";
import type {ILightPredictionsStore} from "data/stores/light_predictions/light_predictions.store";
import {createPredictionPayload} from "data/utils/predictions";
import type {IConferencesStore} from "data/stores/conferences/conferences.store";

export interface IModalLosePicksController extends ViewController {
	i18n: ILocalizationStore;

	get isOpen(): boolean;
	get modalContent(): IModalPayload | null;

	close: () => void;
	onLoginBySSO: () => void;
}

@injectable()
export class ModalLosePicksController implements IModalLosePicksController {
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore,
		@inject(Bindings.LightPredictionsStore) private _lpStore: ILightPredictionsStore,
		@inject(Bindings.ConferencesStore) private _conferencesStore: IConferencesStore
	) {
		makeAutoObservable(this);
	}

	get isOpen(): boolean {
		return this._modalsStore.modal === ModalType.LOSE_PICKS;
	}

	get modalContent() {
		return this._modalsStore.modalContent;
	}

	close = () => {
		this._modalsStore.hideModal();
	};

	private SSOLogin = () => {
		window.gigya?.sso.login({
			authFlow: "redirect",
			apiKey: GIGYA_KEY,
		});
	};

	private setLocalPredictions = () => {
		const predictions = createPredictionPayload(
			this._lpStore.lightPrediction,
			this._conferencesStore.nfcConferenceId,
			this._conferencesStore.afcConferenceId
		);

		localStorage.setItem("localPredictions", JSON.stringify(predictions));
	};

	onLoginBySSO = () => {
		this.setLocalPredictions();
		this.SSOLogin();
	};
}
